import BaseCellRenderer, { IBaseCellRendererParams } from "./BaseCellRenderer";

export default function PercentCellRenderer(props: IBaseCellRendererParams<number>) {
    const decimal = props.valueFormatted != null ? (props.valueFormatted === "" ? null : Number.parseFloat(props.valueFormatted)) : props.value;

    return (
        <BaseCellRenderer {...props}>
            {decimal != null && <>{decimal.formatAsPrice(true)}%</>}
        </BaseCellRenderer>
    );
}